<div class="animated fadeInRight">
  <!-- MENU DE TITULOS -->
  <app-lfsa-card-v2 [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplateEdit"
                    [modulo]="DAT_TITULOS.modulo" [tituloCard]="DAT_TITULOS.titulo" [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <!-- MENU DE TITULOS -->

  <!-- OPCIONES LATERAL IZQUIERDO -->
  <ng-template #innTemplateButton>
    <div class="col-md-6 mb-2">
      <div class="pagetitle">
        <div class="btn-group-justified btn-group" style="float: right;">
          <button (click)="nuevoValorFlete()" class="btn btn-outline-success">
            <i aria-hidden="true" class="fa fa-plus"></i>
            {{DAT_TITULOS.tituloAgregar}}
          </button>
        </div>
      </div>
    </div>
  </ng-template>
  <!-- OPCIONES LATERAL IZQUIERDO -->

  <!-- GRILLA -->
  <ng-template #enviarTemplateEdit>
    <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
    <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [class]="DAT_AG_GRID.class" [columnDefs]="columnDefs"
                     [floatingFilter]="true" [frameworkComponents]="frameworkComponents" [id]="DAT_AG_GRID.id"
                     [ngStyle]="DAT_AG_GRID.style" [paginationPageSize]="DAT_AG_GRID.paginacion" [pagination]="true"
                     [rowData]="rowData">
      [rowSelection]="'single'"
    </ag-grid-angular>
  </ng-template>
  <!-- GRILLA -->
</div>

<!-- MODAL -->
<app-lfsa-modal [classModal]="'modal-lg'" [idButton]="'abrirModalAgregarValorFlete'"
                [idClose]="'cerrarModalAgregarGarita'" [innTemplate]="abrirModalAgregarValorFlete"
                [titulo]="tituloModal"></app-lfsa-modal>
<ng-template #abrirModalAgregarValorFlete>
  <div class="container-fluid">
    <form [formGroup]="agregarValorFlete" mat-dialog-content>
      <div *ngIf="!isCreate" class="mb-2">
        <label for="">ID</label>
        <input class="form-control" formControlName="id" id="id" name="id" readonly type="text">
      </div>
      <div class="row">
        <div class="col-6">
          <div class="mb-2">
            <label for="">Código de Proveedor (seleccione un origen para cargar este valor)</label>
            <input (change)="onChangeProveedor($event);" (keydown)="noWhitespace($event)"
                   (keyup)="onChangeProveedor($event);this.agregarValorFlete.controls['provee'].value.length > 0 ? onChangeValues() : ''"
                   autocomplete="off" class="form-control"
                   formControlName="provee" name="provee"
                   type="text">
            <div *ngIf="proveeControl?.hasError('required') && proveeControl.touched" class="text-danger">
              <small>*Este campo es requerido</small>
            </div>
            <div *ngIf="proveedorInvalido" class="text-danger">
              <small>*Este proveedor es inválido</small>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="mb-2">
            <label for="">Desc. Proveedor</label>
            <input autocomplete="off" class="form-control" formControlName="despro" name="despro" readonly type="text">
          </div>
        </div>
        <div class="col-6">
          <div class="mb-2">
            <label for="">Origen extractora</label>
            <!--
             <input (change)="onChangeCodOrigen($event)" (keydown)="noWhitespace($event)"
                   (keyup)="onChangeCodOrigen($event); this.agregarValorFlete.controls['codori'].value.length > 0 ? onChangeValues() : ''"
                   autocomplete="off" class="form-control" formControlName="codori" name="codori" type="text">
             -->      
              <select class="form-control" formControlName="codori" name="codori" (change)="onChangeCodOrigen($event)">
                <option value="">-- Seleccione --</option>
                <option *ngFor="let origen of origenesExtractoras" [value]="origen.id">{{origen.id}} - {{origen.descripcion}}</option>
              </select>                    
            <div *ngIf="cod_origenControl?.hasError('required') && cod_origenControl.touched" class="text-danger">
              <small>*Este campo es requerido</small>
            </div>            
            <div *ngIf="origenInvalido" class="text-danger">
              <small>*Este origen es inválido</small>
            </div>
          </div>
        </div>

        <div class="col-6">
          <div class="mb-2">
            <label for="">Desc. Origen</label>
            <input autocomplete="off" class="form-control" formControlName="desori" name="desori" readonly type="text">
          </div>
        </div>
        <div class="col-6">
          <div class="mb-2">
            <label for="">Material</label>
            <input (change)="onChangeMaterial($event)" (keydown)="noWhitespace($event)"
                   (keyup)="onChangeMaterial($event);this.agregarValorFlete.controls['mat'].value.length > 0 ? onChangeValues(): ''"
                   autocomplete="off" class="form-control"
                   formControlName="mat" name="mat"
                   type="text">
            <div *ngIf="materialControl?.hasError('required') && materialControl.touched" class="text-danger">
              <small>*Este campo es requerido</small>
            </div>
            <div *ngIf="materialInvalido" class="text-danger">
              <small>*Este material es inválido</small>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="mb-2">
            <label for="">Desc. Material</label>
            <input autocomplete="off" class="form-control" formControlName="desmat" name="desmat" readonly type="text">
          </div>
        </div>
        <div class="col-6">
          <div class="mb-2">
            <label for="">Fecha Inicial</label>
            <input (change)="onChangeValues()" autocomplete="off" class="form-control" formControlName="fechaini"
                   name="fechaini"
                   type="date">
          </div>
        </div>
        <div class="col-6">
          <div class="mb-2">
            <label for="">Fecha Final</label>
            <input (change)="onChangeValues()" autocomplete="off" class="form-control" formControlName="fechafin"
                   name="fechafin"
                   placeholder="dd-mm-yyyy" type="date">
            <small *ngIf="fecha_finControl?.hasError('required') && fecha_finControl.touched" class="text-danger">
              *Este campo es requerido
            </small>
            <small *ngIf="dateNotLessCurrent" class="text-danger">
              *La Fecha Final no puede ser menor a la Fecha Inicial
            </small>
          </div>
        </div>

        <div class="col-12">
          <div class="mb-2">
            <label for="">Precio</label>
            <input (keypress)="keyDecimals($event)" autocomplete="off" class="form-control" formControlName="precio"
                   name="precio"
                   type="text">
            <small *ngIf="precioControl?.hasError('required') && precioControl.touched" class="text-danger">
              *Este campo es requerido
            </small>
            <small *ngIf="precioControl?.hasError('pattern') && precioControl.touched" class="text-danger">
              *Solo números y punto, hasta 4 decimales. Ej: 12.3456
            </small>
          </div>
        </div>
      </div>

      <div *ngIf="dateValidate" class="mt-3 mb-2 text-danger">
        *No se puede crear un registro con el mismo proveedor, código de origen y material, cuando
        la fecha actual se encuentre entre la fecha inicio y fecha fin, como en el siguiente registro:
      </div>
      <div *ngIf="dateValidate" class="mb-4">
        <table class="w-100 table table-bordered">
          <tr>
            <th>Proveedor</th>
            <th>Código de Origen</th>
            <th>Material</th>
            <th>Fecha Inicial</th>
            <th>Fecha Final</th>
            <th>Precio</th>
          </tr>
          <tr>
            <td>{{ dateValidateData.provee }}</td>
            <td>{{ dateValidateData.codori }}</td>
            <td>{{ dateValidateData.mat }}</td>
            <td>{{ dateValidateData.fechaini }}</td>
            <td>{{ dateValidateData.fechafin }}</td>
            <td>{{ dateValidateData.precio }}</td>
          </tr>
        </table>
      </div>
      <app-lfsa-botones-formulario (devolverAccion)="acciones($event)" [formularioValido]="validForm()"
                                   [loading]="loading" [textBoton]="'Guardar'" class="row">
      </app-lfsa-botones-formulario>

    </form>
  </div>
</ng-template>
<!-- END MODAL -->
